// extracted by mini-css-extract-plugin
export default {"modal":"AuthModalWrapper_modal__LJVVO"};